document.addEventListener('DOMContentLoaded', function() {
  var body = document.body;

  var isMerchPage =
    body.classList.contains('template-product-merch') ||
    body.classList.contains('template-product-merch-tees') ||
    body.classList.contains('pathos-merch') ||
    window.location.pathname.indexOf('/merch') !== -1;

  if (isMerchPage) return;

  var button = document.querySelector('button.product-form__submit');
  if (!button) return console.warn('[DP] button not found');

  var form = button.closest('form');
  if (!form) return console.warn('[DP] form not found');

  var priceSpan = button.querySelector('.dynamic-price');
  if (!priceSpan) {
    priceSpan = document.createElement('span');
    priceSpan.className = 'dynamic-price';
    priceSpan.style.marginLeft = '0.2em';
    priceSpan.style.fontSize = '0.9em';
    button.appendChild(priceSpan);
  }

  if (!button.querySelector('.btn-icon')) {
    var headerSvg = document.querySelector('#cart-icon-bubble svg');
    if (headerSvg) {
      var svgClone = headerSvg.cloneNode(true);

      svgClone.removeAttribute('fill');
      svgClone.removeAttribute('stroke');
      svgClone.setAttribute('width', '2em');
      svgClone.setAttribute('height', '2em');
      svgClone.style.display = 'inline-block';
      svgClone.style.verticalAlign = 'middle';

      svgClone.querySelectorAll('*').forEach(function(el) {
        var tag = el.tagName.toLowerCase();
        if (tag === 'path' || tag === 'circle' || tag === 'rect') {
          el.setAttribute('fill', '#fff');
          el.setAttribute('stroke', '#fff');
          el.setAttribute('stroke-width', '0.04em');
          el.setAttribute('stroke-linejoin', 'round');
          el.setAttribute('stroke-linecap', 'round');
        }
      });

      svgClone.querySelectorAll('*').forEach(function(el) {
        if (el.hasAttribute('fill')) el.setAttribute('fill', '#fff');
        if (el.hasAttribute('stroke')) el.setAttribute('stroke', '#fff');
      });

      var iconWrapper = document.createElement('span');
      iconWrapper.className = 'btn-icon';
      iconWrapper.style.display = 'inline-flex';
      iconWrapper.style.verticalAlign = 'middle';
      iconWrapper.style.margin = '0 0.1em';
      iconWrapper.appendChild(svgClone);

      button.insertBefore(iconWrapper, priceSpan);
    } else {
      console.warn('[DP] header SVG not found at #cart-icon-bubble svg');
    }
  }

var mainText = button.querySelector('.main-atc-text');

if (!mainText) {
  mainText = button.querySelector('span');

  if (mainText) {
    mainText.classList.add('main-atc-text');
  }
}

if (mainText) {
  mainText.textContent = 'Add to bag';
}

  var m = window.location.pathname.match(/\/products\/([^\/]+)/);
  if (!m) return console.warn('[DP] no product handle in URL');

  var productPromise = fetch('/products/' + m[1] + '.js')
    .then(function(res) { return res.json(); })
    .catch(function(err) {
      console.error('[DP] fetch error', err);
      return null;
    });

  function cleanText(t) {
    return (t || '').replace(/\s+/g, ' ').trim();
  }

  function findPriceRoot() {
    return (
      document.querySelector('[id^="price-"]') ||
      document.querySelector('.product__info-container .price') ||
      document.querySelector('.product__info-container [class*="price"]') ||
      document.querySelector('.price') ||
      null
    );
  }

  function getDisplayedUnitPriceText() {
    var root = findPriceRoot();
    if (!root) return '';

    var candidates = [
      '.price__sale .price-item--sale',
      '.price__sale .price-item--last',
      '.price__regular .price-item--regular',
      '.price-item--sale',
      '.price-item--regular',
      '.price-item'
    ];

    for (var i = 0; i < candidates.length; i++) {
      var el = root.querySelector(candidates[i]);
      var txt = cleanText(el && el.textContent);
      if (txt) return txt;
    }

    return cleanText(root.textContent);
  }

  function moneyTextToCents(text) {
    if (!text) return null;

    var s = text.replace(/[^\d.,-]/g, '').trim();
    if (!s) return null;

    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');

    var decimalSep = null;
    if (lastDot > -1 || lastComma > -1) {
      decimalSep = (lastDot > lastComma) ? '.' : ',';
    }

    if (decimalSep === ',') {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (decimalSep === '.') {
      s = s.replace(/,/g, '');
    }

    var n = Number(s);
    if (!isFinite(n)) return null;

    return Math.round(n * 100);
  }

  var lastVid, lastQty, lastUnitCents;

  function updatePrice() {
    Promise.resolve(productPromise).then(function(product) {
      if (!product) return;

var idInput = form.querySelector('input[name="id"]');
if (!idInput) return;

var vid = Number(idInput.value);

// Check the current URL variant if the form input is stale
var urlVariant = new URLSearchParams(window.location.search).get('variant');

if (urlVariant && Number(urlVariant) !== vid) {
  vid = Number(urlVariant);
}

var qty = parseInt(new FormData(form).get('quantity'), 10) || 1;

      var displayedText = getDisplayedUnitPriceText();
      var unitCentsFromDisplay = moneyTextToCents(displayedText);


      lastVid = vid;
      lastQty = qty;
      lastUnitCents = unitCentsFromDisplay;

      var variant = product.variants.find(function(v) {
        return v.id === vid;
      });

      if (!variant) {
        console.warn('[DP] variant not found for id', vid);
        return;
      }

      var unitPriceCents = unitCentsFromDisplay;
      if (unitPriceCents == null || !isFinite(unitPriceCents) || unitPriceCents <= 0) {
        unitPriceCents = variant.price;
      }

      var subtotal = unitPriceCents * qty;
      if (qty >= 3) subtotal = Math.round(subtotal * 0.8);

      var formatted;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = window.moneyFormat || window.Shopify.money_format || window.Shopify.moneyFormat || '${{amount}}';
        formatted = window.Shopify.formatMoney(subtotal, fmt);
      } else {
        try {
          var currency = window.shopCurrency || (Shopify.currency && Shopify.currency.active) || 'GBP';
          formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(subtotal / 100);
        } catch (e) {
          formatted = (subtotal / 100).toFixed(2);
        }
      }

      formatted = formatted.replace(/^[A-Z]{1,3}\s*/, '');

// Find the currently displayed Add to bag button
var currentButton = document.querySelector('button.product-form__submit');

if (!currentButton) return;

// Find or recreate the price element
var currentPriceSpan = currentButton.querySelector('.dynamic-price');

if (!currentPriceSpan) {
  currentPriceSpan = document.createElement('span');
  currentPriceSpan.className = 'dynamic-price';
  currentPriceSpan.style.marginLeft = '0.2em';
  currentPriceSpan.style.fontSize = '0.9em';
  currentButton.appendChild(currentPriceSpan);
}

// Update the visible price
currentPriceSpan.textContent = ' ' + formatted;
      button.disabled = !variant.available;
      button.classList.toggle('btn--disabled', !variant.available);
    });
  }

  updatePrice();
  setInterval(updatePrice, 300);
});